"use client";

import { useContext } from "react";
import { UserContext } from "@/contexts/user-context";
import { ResourceContext } from "@/contexts/resource-context";

export function AccessInfo({ children }: { children: any }) {
  const { isCrawler } = useContext(UserContext) as User;
  const { access } = useContext(ResourceContext) as ResourceInfo;

  if (!access?.granted || isCrawler) {
    return <>{children}</>;
  }

  return <></>;
}
